/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NavLink from './common/NavLink';
import {
  switchAccount,
  saveFeedback,
  impersonatUser,
  exitImpersonate,
  searchUsers,
  logOut,
  perferedAccount,
} from '../actions/loginActions';
import ChatBox from './chatbox/ChatBox';

import crosstabIcon from '../images/edge-icon.png';
import insightIcon from '../images/catalyst-icon.png';
import analyticsIcon from '../images/analytics-icon.png';
import crosstabIconBlue from '../images/edge-icon-active.png';
import insightIconBlue from '../images/catalyst-icon-active.png';
import analyticsIconblue from '../images/analytics-icon-active.png';
import userGuideIcon from '../images/user-guide-icon_white.png';
import userIconBlue from '../images/user_icon_blue.png';
import userIconWhite from '../images/user_icon_white.png';
import userGuideIconBlue from '../images/user_guide_icon.png';

import * as urls from '../actions/urlTypes';
import { storeUnsavedData } from '../util/trackerUtils';
import * as messages from '../messages/NavigationMessages';
import EssentialsNav from './EssentialsNav';
import CatalystNav from './CatalystNav';
import OmnibusNav from './OmnibusNav';
import EnablementNav from './EnablementNav';
import MriSimmonsWhiteLogo from './common/MriSimmonsWhiteLogo';
import {
  PREFERENCE_POPUP_LABEL,
  ENABLEMENT_MODULE_ID,
  PROD_HOST,
  PROD_CATALYST_URL,
  BETA_HOST,
  BETA_CATALYST_URL,
} from '../constants';
import { isModulePresent } from '../util/CommonUtils';
import EnablementIcon from './common/EnablementIcon';

const StartDefault = () => (
  <svg
    enableBackground="new 0 0 50 50"
    height="26px"
    viewBox="0 0 50 50"
    width="26px"
    xmlSpace="preserve"
  >
    <rect fill="none" height="50" width="50" />
    <polygon
      fill="none"
      points="25,3.553 30.695,18.321 46.5,19.173   34.214,29.152 38.287,44.447 25,35.848 11.712,44.447 15.786,29.152 3.5,19.173 19.305,18.321 "
      stroke="#30435D"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
  </svg>
);
const StartActive = () => (
  <svg height="27px" version="1.1" viewBox="0 0 20 21" width="26px">
    <g fill="none" fillRule="evenodd" id="Page-1" stroke="none" strokeWidth="1">
      <g
        fill="#30435D"
        id="Core"
        transform="translate(-296.000000, -422.000000)"
      >
        <g id="star" transform="translate(296.000000, 422.500000)">
          <path
            d="M10,15.273 L16.18,19 L14.545,11.971 L20,7.244 L12.809,6.627 L10,0 L7.191,6.627 L0,7.244 L5.455,11.971 L3.82,19 L10,15.273 Z"
            id="Shape"
          />
        </g>
      </g>
    </g>
  </svg>
);

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isprofileDropdownMenuActive: false,
      show: true,
      isHidden: true,
      minimize: false,
      flag: 0,
      userList: '',
      perferedAccountId: '',
    };
    this.showFeedbackSection = this.showFeedbackSection.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    if (this.props.preferredAccountId) {
      this.setState({ perferedAccountId: this.props.preferredAccountId });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { preferredAccountId } = nextProps;
    const { perferedAccountId } = this.state;
    if (preferredAccountId && preferredAccountId !== perferedAccountId) {
      this.setState({
        perferedAccountId: preferredAccountId,
        isprofileDropdownMenuActive: false,
      });
    }
  }

  userLogout = () => {
    const state = this.props.currentState;
    const uid = this.props.loginResponse.data.uid;
    const accountId = this.props.activeAccountId;
    const universityUser = this.props.loginResponse.data.universityUser;
    logOut(state, uid, accountId, universityUser);
  };

  // event handler function
  onClickAuth = e => {
    e.preventDefault();
    if (!sessionStorage.unsavedPrefData) {
      this.userLogout();
    } else {
      const result = window.confirm(PREFERENCE_POPUP_LABEL);
      if (result) {
        this.userLogout();
      }
    }
  };

  handleSaveFeedback = (feedback, section, comments) => {
    this.props.saveFeedback(
      this.props.loginResponse.data.token,
      this.props.loginResponse.data.uid,
      this.props.account.data[0].accountId,
      feedback,
      section,
      comments
    );
  };

  showFeedbackSection = () => {
    const { show } = this.state;
    this.setState({
      show: !show,
    });
  };

  handleFeedbackSection = () => {
    this.showFeedbackSection();
    this.toggleIcons3();
  };

  toggleProfileButton = () =>
    this.setState(prevState => ({
      isprofileDropdownMenuActive: !prevState.isprofileDropdownMenuActive,
    }));

  toggleIcons1 = () =>
    this.setState(prevState => ({ isIconActive1: !prevState.isIconActive1 }));

  toggleIcons2 = () =>
    this.setState(prevState => ({ isIconActive2: !prevState.isIconActive2 }));

  toggleIcons3 = () =>
    this.setState(prevState => ({ isIconActive3: !prevState.isIconActive3 }));

  toggleIcons4 = () =>
    this.setState(prevState => ({ isIconActive4: !prevState.isIconActive4 }));

  toggleIcons5 = () =>
    this.setState(prevState => ({ isIconActive5: !prevState.isIconActive5 }));

  toggleIcons6 = () =>
    this.setState(prevState => ({ isIconActive6: !prevState.isIconActive6 }));

  toggleIcons7 = () =>
    this.setState(prevState => ({ isIconActive7: !prevState.isIconActive7 }));

  toggleIcons8 = () =>
    this.setState(prevState => ({ isIconActive8: !prevState.isIconActive8 }));

  toggleHidden = () => {
    if (!this.state.isHidden) {
      document.addEventListener('click', this.handleOutsideClick, false);
    } else {
      document.removeEventListener('click', this.handleOutsideClick, false);
    }

    if (this.state.flag === 1) {
      // console.log(this.flag);
      this.setState(prevState => ({ minimize: !prevState.minimize }));
    } else {
      this.setState(prevState => ({
        isHidden: !prevState.isHidden,
      }));
      this.state.flag = 1;
    }
  };

  closeChat = () => {
    this.setState({
      isHidden: true,
      flag: 0,
    });
  };

  handleImpersonate = e => {
    let email = e;
    if (e.target && e.target.email.value) {
      e.preventDefault();
      email = e.target.email.value;
    }
    if (email !== 'User not found!') {
      impersonatUser(email);
    }
  };

  openImpersonateForm = () => {
    this.impersonateInput.value = '';
    this.impersonateInput.focus();
  };

  onPreferedAccountClick = accountId => {
    this.props.perferedAccount(accountId);
  };

  onLaunchClick = () => {
    if (window.location.hostname === PROD_HOST) {
      window.open(`${PROD_CATALYST_URL}/v2/homepage`, '_blank');
    } else if (window.location.hostname === BETA_HOST) {
      window.open(`${BETA_CATALYST_URL}/v2/homepage`, '_blank');
    } else {
      window.open(`${urls.APP_ROOT_URL}/v2/homepage`, '_blank');
    }
  };

  handleSearchUsers = e => {
    const user = e.target.value;
    if (user.length > 2) {
      searchUsers(user).then(user => {
        // console.log(user);
        if (this.state.userList !== user) {
          this.setState({
            userList: user.length > 0 ? user : ['User not found!'],
          });
        }
      });
    }
  };

  handleOutsideClick(e) {
    // ignore clicks on the component itself
    if (this.node.contains(e.target)) {
      return;
    }
    this.toggleHidden();
  }

  renderOmnibusNav = () => {
    const { loginResponse } = this.props;
    const { impersonated } = loginResponse.data;
    if (impersonated) {
      return null;
    }

    return (
      <li>
        <NavLink onMouseOver={this.toggleIcons6} onMouseOut={this.toggleIcons6}>
          <img
            src={this.state.isIconActive6 ? crosstabIcon : crosstabIconBlue}
            alt="Omnibus Icon"
          />
          Omnibus
        </NavLink>
        <div className="nav-dropdown-menu">
          <OmnibusNav />
        </div>
      </li>
    );
  };

  renderDataEnablementNav = () => {
    return (
      <li>
        <NavLink onMouseOver={this.toggleIcons8} onMouseOut={this.toggleIcons8}>
          <EnablementIcon
            size={25}
            color={this.state.isIconActive8 ? '#b2becd' : '#91a2b9'}
          />
          DataHub
        </NavLink>
        <div className="nav-dropdown-menu">
          <EnablementNav />
        </div>
      </li>
    );
  };

  navigateToSupportPage = () => {
    if (window.location.hostname.includes(PROD_HOST)) {
      window.open(`${PROD_CATALYST_URL}/v2/support`, '_blank')
    } else if (window.location.hostname.includes(BETA_HOST)) {
      window.open(`${BETA_CATALYST_URL}/v2/support`, '_blank')
    } else {
      window.open(`${urls.APP_ROOT_URL}/v2/support`, '_blank')
    }
  }

  render() {
    return (
      <div>
        <nav className="main-nav" id="top-navigation">
          <div className="main-nav--left">
            <div className="nav-logo">
              <a
                href={urls.SIMMONS_RESEARCH_PROD_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                <MriSimmonsWhiteLogo />
              </a>
            </div>
          </div>
          {this.props.hasAccount && (
            <div className="main-nav-navigation">
              <ul className="main-nav-list">
                <li>
                  <NavLink
                    onMouseOver={this.toggleIcons4}
                    onMouseOut={this.toggleIcons4}
                  >
                    <img
                      src={
                        this.state.isIconActive4
                          ? analyticsIconblue
                          : analyticsIcon
                      }
                      alt="Crosstab Icon"
                    />
                    Essentials
                  </NavLink>
                  <div className="nav-dropdown-menu">
                    <EssentialsNav />
                  </div>
                </li>
                <li>
                  <NavLink
                    onMouseOver={this.toggleIcons5}
                    onMouseOut={this.toggleIcons5}
                  >
                    <img
                      src={
                        this.state.isIconActive5 ? insightIconBlue : insightIcon
                      }
                      alt="Insight Icon"
                    />
                    Catalyst
                  </NavLink>
                  <div className="nav-dropdown-menu">
                    <CatalystNav />
                  </div>
                </li>
                {this.renderOmnibusNav()}
                {!this.props.isTPAccount &&
                  !this.props.loginResponse.data.universityUser &&
                  this.renderDataEnablementNav()}
              </ul>
            </div>
          )}
          <div className="launch-version">
            <button type="button" onClick={() => this.onLaunchClick()}>
              Launch 2.0
            </button>
          </div>
          <div className="profile-nav">
            <div className="nav-notification">
              <div className="nav-notification-icon">
                <NavLink
                  // to={`${urls.APP_ROOT_URL}/support`}
                  rel="noopener noreferrer"
                  target="_blank"
                  onClick={this.navigateToSupportPage}
                  className="nav-button"
                  onMouseOver={this.toggleIcons1}
                  onMouseOut={this.toggleIcons1}
                  title="Support"
                >
                  <img
                    className="img-responsive"
                    src={
                      this.state.isIconActive1
                        ? userGuideIcon
                        : userGuideIconBlue
                    }
                    alt="support"
                  />
                </NavLink>
              </div>
            </div>
            <div
              className="profile-section"
              onMouseOver={this.toggleProfileButton}
              onMouseOut={this.toggleProfileButton}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              <button
                type="button"
                className={`${
                  this.state.isprofileDropdownMenuActive ? 'active' : ''
                } button profile-button`}
              >
                <img
                  className="img-responsive user-icon"
                  src={
                    this.state.isprofileDropdownMenuActive
                      ? userIconWhite
                      : userIconBlue
                  }
                  alt="user-icon"
                />
              </button>
              <div className="profile-user-info">
                <span
                  className="profile-name"
                  title={
                    this.props.currentAccount.accountName +
                    (this.props.currentAccount.accountType === 'TPP'
                      ? ' (Third Party)'
                      : '')
                  }
                >
                  {this.props.currentAccount.accountName +
                    (this.props.currentAccount.accountType === 'TPP'
                      ? ' (Third Party)'
                      : '')}
                </span>
                {!this.props.loginResponse.data.universityUser && (
                  <span
                    className="profile-user"
                    title={this.props.loginResponse.data.username}
                  >
                    {this.props.loginResponse.data.username}
                  </span>
                )}
              </div>
              <ul
                className={`${
                  this.state.isprofileDropdownMenuActive ? 'active' : ''
                } profileDropdownMenu`}
              >
                {!this.props.isTPAccount &&
                  !this.props.loginResponse.data.universityUser &&
                  this.props.hasAccount && (
                    <li>
                      <NavLink to={`${urls.APP_ROOT_URL}/user-preference`}>
                        {messages.MY_PREFERENCE}
                      </NavLink>
                    </li>
                  )}
                {this.props.hasAccount && (
                  <li>
                    <NavLink
                      href="#"
                      onClick={e => e.preventDefault()}
                      title="Coming Soon..."
                    >
                      {messages.MY_INFO}
                    </NavLink>
                  </li>
                )}
                {!this.props.loginResponse.data.impersonated &&
                  !this.props.loginResponse.data.universityUser &&
                  this.props.isStudy &&
                  this.props.hasAccount &&
                  !this.props.isSSOAccount && (
                    <li>
                      <NavLink to={`${urls.APP_ROOT_URL}/change-password`}>
                        {messages.CHANGE_PASSWORD}
                      </NavLink>
                    </li>
                  )}
                {this.props.account.data.length > 1 &&
                  this.props.loginResponse.data.universityUser === false && (
                    <li className="switch-account">
                      <button type="button" className="swith-account-nav">
                        {messages.SWITCH_ACCOUNT}
                      </button>
                      {this.props.account.data && (
                        <ul className="switch-account-dropdown">
                          {this.props.account.data.map((account, i) => (
                            <li
                              key={`accountId_${account.accountId}`}
                              data-key={`${i}_${account.accountId}`}
                              className={
                                this.props.loginResponse.data
                                  .currentAccountId === account.accountId
                                  ? 'swith-account-nav-list active'
                                  : 'swith-account-nav-list'
                              }
                            >
                              {this.props.loginResponse.data
                                .currentAccountId === account.accountId ? (
                                <div className="preferred-account">
                                  {this.state.perferedAccountId ===
                                  account.accountId ? (
                                    <span className="preferred-icon">
                                      <StartActive />
                                    </span>
                                  ) : (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        this.onPreferedAccountClick(
                                          account.accountId
                                        )
                                      }
                                      className="preferred-account-selection"
                                    >
                                      <StartDefault />
                                    </button>
                                  )}
                                  <span>
                                    {account.accountName +
                                      (account.accountType === 'TPP'
                                        ? ' (Third Party)'
                                        : '')}
                                  </span>
                                </div>
                              ) : (
                                <div className="preferred-account">
                                  {this.state.perferedAccountId ===
                                  account.accountId ? (
                                    <span className="preferred-icon">
                                      <StartActive />
                                    </span>
                                  ) : (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        this.onPreferedAccountClick(
                                          account.accountId
                                        )
                                      }
                                      className="preferred-account-selection"
                                    >
                                      <StartDefault />
                                    </button>
                                  )}
                                  <button
                                    type="button"
                                    onClick={() =>
                                      switchAccount(
                                        account.accountId,
                                        account.accountName
                                      )
                                    }
                                    // title={account.accountName}
                                  >
                                    {account.accountName}
                                  </button>
                                </div>
                              )}
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  )}
                {this.props.loginResponse.data.internalAdmin &&
                  !this.props.isTPAccount && (
                    <li>
                      <NavLink to={`${urls.APP_ROOT_URL}/admin/users`}>
                        {messages.ADMIN}
                      </NavLink>
                    </li>
                  )}
                {this.props.loginResponse.data.attributes.IS_CONTRACT_ADMIN ===
                  '1' &&
                  !this.props.isTPAccount && (
                    <li>
                      <NavLink to={`${urls.APP_ROOT_URL}/ContractAdmin`}>
                        {messages.CONTRACT_ADMIN}
                      </NavLink>
                    </li>
                  )}
                {!this.props.loginResponse.data.impersonated &&
                  !this.props.loginResponse.data.universityUser &&
                  this.props.loginResponse.data.attributes
                    .DATA_APPEND_ACCESS === '1' && (
                    <li>
                      <a
                        rel="noopener noreferrer"
                        target="_blank"
                        href={`${urls.APP_ROOT_URL}/v2/dataappend`}
                      >
                        {messages.DATA_APPEND}
                      </a>
                    </li>
                  )}
                {!this.props.loginResponse.data.impersonated &&
                  !this.props.loginResponse.data.universityUser &&
                  this.props.loginResponse.data.attributes.IS_RLD_TOOL_ADMIN ===
                    '1' && (
                    <li>
                      <NavLink to={`${urls.APP_ROOT_URL}/rldtool`}>
                        {messages.RLD_TOOL}
                      </NavLink>
                    </li>
                  )}
                <li>
                  <a
                    href="#"
                    onClick={this.onClickAuth}
                    style={{ fontWeight: 'bold' }}
                  >
                    {messages.LOGOUT}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
        {this.props.loginResponse.data.impersonated && (
          <div className="impersonate-warning-bar">
            <p>
              You are currently in impersonation mode.{' '}
              <button
                type="button"
                onClick={() => exitImpersonate()}
                className="impersonate-exit"
              >
                End impersonation
              </button>
            </p>
          </div>
        )}
        <div
          ref={node => {
            this.node = node;
          }}
        >
          {!this.state.isHidden && (
            <ChatBox
              toggleHidden={this.toggleHidden}
              closeChat={this.closeChat}
              minimize={this.state.minimize}
            />
          )}
        </div>
      </div>
    );
  }
}

Navigation.propTypes = {
  isStudy: PropTypes.oneOfType([PropTypes.instanceOf(Array), PropTypes.bool]),
  hasAccount: PropTypes.bool,
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      uid: PropTypes.number,
      token: PropTypes.string,
      currentAccountId: PropTypes.number,
      preferredAccountId: PropTypes.number,
      username: PropTypes.string,
      canImpersonate: PropTypes.bool,
      impersonated: PropTypes.bool,
      universityUser: PropTypes.bool,
      internalAdmin: PropTypes.bool,
      isContractAdmin: PropTypes.bool,
      attributes: PropTypes.shape({
        IS_CONTRACT_ADMIN: PropTypes.string,
      }),
    }),
  }),

  saveFeedback: PropTypes.func,
  perferedAccount: PropTypes.func,
  preferredAccountId: PropTypes.number,
  account: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
  }),
  isTPAccount: PropTypes.bool,
  isSSOAccount: PropTypes.bool,
  currentAccount: PropTypes.instanceOf(Object),
  userDetail: PropTypes.instanceOf(Object),
  currentState: PropTypes.shape({}),
  activeAccountId: PropTypes.number,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    account: state.account.accounts,
    activeAccountId: state.account.activeAccountId,
    preferredAccountId: state.account.preferredAccountId,
    currentState: state,
    isTPAccount: state.account.isTPAccount,
    isSSOAccount: state.account.isSSOAccount,
    currentAccount: state.account.currentAccount,
    userDetail: state.userDetail,
    // isContractAdmin:
  };
}

function mapDispatchToProps(dispatch) {
  return {
    saveFeedback: bindActionCreators(saveFeedback, dispatch),
    storeUnsavedData: bindActionCreators(storeUnsavedData, dispatch),
    perferedAccount: bindActionCreators(perferedAccount, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
